<div class="workspace-container">
	<div class="query-strip-container mat-elevation-z2">

        <table height="100%" class="table-title-cell">
            <TR>

                <TD style="width: 25%; text-align: left; padding-left: 10px">
                    <i class="fa  fa-medkit fa-fw table-icon-header" style="width: 2em"></i>{{formTitle}}
                </TD>
                <TD align="left" style="width: 35%;text-align: center;">
                    <input text id="txtFilter" #txtFilter
                           class="qs_filter-field" [disabled]="busyCursor"
                           [(ngModel)]="strFilterText"
                           matTooltip = "Type to match data in all columns except date fields"
                           (keyup)="applyFilter($event.target.value)" placeholder="<Filter>">
                    <button mat-button matSuffix mat-icon-button [disabled]="busyCursor"
                            matTooltip="Clear the filter" aria-label="Clear"
                            (click)="txtFilter.value=''; clearFilter();">
                        <mat-icon style="scale: 80%;">close</mat-icon>
                    </button>
                    <button mat-button matSuffix mat-icon-button
                            matTooltip="Refresh the grid" aria-label="Refresh"
                            (click)="txtFilter.value=''; refreshButtonClickHandler();">
                        <mat-icon style="scale: 80%;">refresh</mat-icon>
                    </button>

                    <button mat-button class="command-button" [disabled]="isEditing"
                            matTooltipPosition="below"
                            style="margin-top: 5px; width:100px;"
                            matTooltip="Query the system for service request records"
                            (click)="openSearchDialog()"
                            mat-button>
                        <mat-icon>search</mat-icon>
                        Search
                    </button>

                </TD>
                <TD class="qs-label-cell"
                    style="font-size: 10pt; width: 15%; text-align: right;">Status:&nbsp;&nbsp;

                    <mat-select
                            disableOptionCentering
                            [(value)]="selectedStatusFilter" floatLabel="never"
                            class="dw-mat-select"
                            style="font-size: 10pt;width: 120px;"
                            panelClass="local-drop-down-panel"
                            (selectionChange)="txtFilter.value=''; onChangeStatusFilterValue()">
                        <mat-option value='All'>All</mat-option>
                        <mat-option value='Active'>Active</mat-option>
                        <mat-option value='InActive'>InActive</mat-option>
                    </mat-select>

                </TD>
                <TD class="table-pagination-cell" align="right" style="width:15%; font-size:10pt;">{{pagination}} Record(s) ...</TD>
            </TR>
        </table>
	</div>

	<mat-drawer-container autosize> <mat-drawer
		position="end" opened="true" class="mat-elevation-z2 drawer-form"
		style="border: .5px solid #e1e1e1" #drawer mode="side"
		disableClose="true">
	<div style="max-width: 455px; padding: 2px;">
		<!-- tab closed state -->
		<table [hidden]="!propContainerState"
			class="prop-notes-outer-container">
			<TR>
				<TD align="left" style="width: 35px; padding: 0;">
					<button id="contract-toggle-drawer-close-btn" mat-icon-button
						(click)="onPropertiesToggle()">
						<mat-icon>arrow_right</mat-icon>
					</button>
				</TD>
				<TD width="100%" style="text-align: left;"><b>Additional
						Properties</b></TD>
				<TD width="35px"></TD>
			</TR>
		</table>
		<!-- tab open State -->
		<div [hidden]="!propContainerState"
			style="width: 450px; height: calc(100% - 60px);">
			<mat-tab-group class="prop-tab-group" selectedIndex="drawerTabIdx"
                           (selectedTabChange)="doDrawerSelectedTabChange($event)">
				<mat-tab label="Suppliers" > <app-medication-suppliers #suppliers
					></app-medication-suppliers> </mat-tab>
				<mat-tab label="Images"> <app-medication-images #images

					></app-medication-images> </mat-tab>
				<mat-tab label="Links"> <app-medication-links #links
					></app-medication-links> </mat-tab> </mat-tab-group>
		</div>
	</div>
	<div>
		<!-- retracted state -->
		<div [hidden]="propContainerState" width="100%">
			<button id="contract-toggle-drawer-open-btn" mat-icon-button
				(click)="onPropertiesToggle()">
				<mat-icon>arrow_left</mat-icon>
			</button>
		</div>

		<div class="rotate-text" [hidden]="propContainerState">
			Additional Properties</div>
	</div>
	</mat-drawer>

	<div class="main-client-area">
		<div #tb1 class="table-container mat-elevation-z1"
			(keydown)="tableKeyDown($event)" tabindex="-1">
			<table *ngIf="selectedViewFilter === 'List';" mat-table
				[dataSource]="dataSource" (keydown)="tableKeyDown($event)"
				(matSortChange)="onSortChange($event)" matSort>

				<!-- ID  -->
				<ng-container matColumnDef="id">
				<th mat-header-cell *matHeaderCellDef mat-sort-header hidden="true"
					class="mat-table-header-style">Id</th>
				<td mat-cell class="mat-table-row-style" style="width: 5% !important;" hidden="true"
					*matCellDef="let element;let tableRowIdx = index;">
					{{element.id}}</td>
				</ng-container>

                <!-- Orig NDC Number -->
                <ng-container matColumnDef="origNdcNumber">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        class="mat-table-header-style" style="padding-left: 5px;">Orig. NDC</th>
                    <td mat-cell class="mat-table-row-style" style="width: 14%; padding-left:5px;"
                        *matCellDef="let element">{{element.origNdcNumber}}</td>
                </ng-container>

                <ng-container matColumnDef="description">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        class="mat-table-header-style">Description</th>
                    <td mat-cell class="mat-table-row-style" style="width: 30%;"
                        *matCellDef="let element">{{element.description}}</td>
                </ng-container>

                <ng-container matColumnDef="manufacturedBy">
					<th mat-header-cell *matHeaderCellDef mat-sort-header
						class="mat-table-header-style">Manu. By</th>
					<td mat-cell class="mat-table-row-style" style="width: 30%;"
                        *matCellDef="let element">{{getManufactByName(element.manufacturedById)}}</td>
				</ng-container>


				<ng-container matColumnDef="packageSize">
				<th mat-header-cell *matHeaderCellDef mat-sort-header
					class="mat-table-header-style"  style="text-align: right;">Size</th>
				<td mat-cell class="mat-table-row-style" style="width: 5%;"
					*matCellDef="let element">{{element.packageSize}}</td>
				</ng-container>

				<ng-container matColumnDef="awp">
				<th mat-header-cell *matHeaderCellDef mat-sort-header
					class="mat-table-header-style" style="text-align: right;">AWP</th>
				<td mat-cell class="mat-table-row-style" style="width:100px;"
                    *matCellDef="let element">$
					{{element.awp}}</td>
				</ng-container>

                <!-- Active Status -->
                <ng-container matColumnDef="activeStatus">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        class="mat-table-header-style"
                        style="background-color: white; z-index:99999">Status
                    </th>
                    <td mat-cell *matCellDef="let element"  class="mat-table-row-style">

                        <dw-dropdown *ngIf="selectedRecord?.id == element.id"
                                     [disabled]="isEditing"
                                     [useStatusOptions]="'status'"
                                     [selectedItem]="element.activeStatus"
                                     [controlWidth]="'100px'"
                                     (itemSelected)="element.activeStatus = $event; onStatusChange()">
                        </dw-dropdown>

                        <span *ngIf="selectedRecord?.id !== element.id" class="mat-table-row-style"
                              style="padding-left: 3px;">{{element.activeStatus}}</span>
                    </td>
                </ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
				<tr mat-row
					*matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
					[ngClass]="{'row-selected': tableRowIdx == Idx}"
					(click)="onRowClicked(row)">
				</tr>

			</table>
			<app-dw-spinner [visible]="busyCursor"></app-dw-spinner>
            <div [hidden]="hideNoRecs" class="no-recs-found">No Records Found</div>
		</div>
		<div class="mat-elevation-z2 control-strip">
			<button *ngIf="visibleAdd" mat-button [disabled]="this.isEditing"
				class="command-button" matTooltip="Add a new record"
					matTooltipPosition="above"
				(click)="addModifyRecord(true)" mat-button>
				<mat-icon>add_circle_outline</mat-icon>
				Add New
			</button>
			<button *ngIf="visibleModify" mat-button class="command-button"
				style="margin-top: 5px;" [disabled]="(Idx < 0|| this.isEditing)"
				matTooltip="Update a selected record"
					matTooltipPosition="above"
				(click)="addModifyRecord(false)" mat-button>
				<mat-icon>edit</mat-icon>
				Update
			</button>
			<button *ngIf="visibleDelete" mat-button class="command-button"
				style="margin-top: 5px;" [disabled]="(Idx < 0 || this.isEditing)"
				matTooltip="Remove a selected record" (click)="removeRecord()"
					matTooltipPosition="above"
				mat-button>
				<mat-icon>remove_circle_outline</mat-icon>
				Remove
			</button>
		</div>
		<div id="medication-details-panel"
			class="medication-inv-container mat-elevation-z2">
			<mat-tab-group animationDuration="0ms"
				(selectedTabChange)="doTabChange($event)"
				[(selectedIndex)]=selectedTabIndex> <mat-tab
				label="Details" [disabled]="isEditing">
			<div class="sub-tab-container-class detail-tab-additional">
				<div class="dwform" style="padding-right: 15px;">

					<div class="dwform-cell-nopadding" style="width: 650px;">
						<div class="dwform-row-double-gap"></div>

						<div class="dwform-row">

							<label style="margin-left: 0px; margin-right: 20px;">Raw NDC Number:</label>
                            <span class="form-required">*</span>
						    <input #rawNDCNumber id="rawNdcNumber"
                                (keydown)="chkInputDigits($event)"
                                (focusout)="deriveOrigFromRaw()"
                                style="width:120px"
								[(ngModel)]="valRawNDCNumber"
                                maxlength="14"
								[disabled]="!isEditing" />
                        </div>

                        <div class="dwform-row-gap"></div>

						<div class="dwform-row">

							<label style="margin-left: 0px; margin-right: 20px;">Orig	NDC Number:</label>
                            <span class="form-required">*</span>
							    <input #omNDCNumber id="ndcNumber"
                                (keydown)="chkInputDigits($event)"
                                style="width:120px"
								[(ngModel)]="valOMNDCNumber"
                                (focusout)="doNDCFocusOut()"
								[disabled]="!isEditing" />

                            <label style="margin-left: 8px; margin-right: 10px;">Format:</label>
                            <dw-dropdown
                                    [disabled]="!isEditing"
                                    [selectedItem]="selectedNdcFormat?.id"
                                    [dataSource]="ndcFormatList"
                                    (itemSelected)="formatNdc($event)"
                                    [controlWidth]="'116px'">

                            </dw-dropdown>
                        </div>

                        <div class="dwform-row-gap"></div>

                        <div class="dwform-row"  >
                            <label class="label-field" style="vertical-align: top">Med. Family:</label> <span
                                class="form-required"></span>

                            <textarea class="text-area-override" [disabled]=true
                                      style="background-color: transparent;"
                                      [(ngModel)]="valMedicationFamily"></textarea>
                            <div style="display:table-cell;vertical-align: middle; width:100px;" *ngIf="isEditing">
                                <button mat-button class="command-button"
                                        (click)="showMedFamilySelection()"
                                        matTooltip="Set medication family"
                                        style="scale: 85%;width:90px;">
                                    <mat-icon>add_circle_outline</mat-icon>
                                    Set
                                </button>
                            </div>
                        </div>

                        <div class="dwform-row-gap"></div>

                        <div class="dwform-row">
                            <label class="label-field" style="vertical-align: top">Description:</label>
                            <span class="form-required" >*</span>

                            <textarea class="input-field text-area-override" placeholder="<description>"
                                      style="text-transform: uppercase"
                                      [disabled]="!isEditing"
                                      [(ngModel)]="valDesc"></textarea>
                        </div>

						<div class="dwform-row-gap"></div>

                        <div class="dwform-row">
                            <label class="label-field">Pkg Size:</label> <span
                                class="form-required">*</span> <input class="input-field"
                                     [disabled]="!isEditing" id="packagesize" placeholder="<size>"
                                     [(ngModel)]="valPkgSize" type="text" style="width: 100px">
                        </div>
                        <div class="dwform-row-gap"></div>
                        <div class="dwform-row">
							<label class="label-field">Status:</label> <span
								class="form-required">*</span>

							<mat-select [disabled]="!isEditing" [(ngModel)]="valStatus"
								id="status" placeholder="- Please Select -"
								disableOptionCentering floatLabel="never"
								panelClass="local-drop-down-panel" class="dw-mat-select"
								style="width: 167px;font-size: 10pt;"
								[style.backgroundColor]="disabledFlag?'whitesmoke':'white'">
							<mat-option value="Active">Active</mat-option> <mat-option
								value="InActive">InActive</mat-option> </mat-select>
						</div>
						<div class="dwform-row-gap"></div>
					</div>

                    <!-- second column -->
					<div class="dwform-cell">
						<div class="dwform-row">
                            <div class="dwform-row-gap"></div>
                                <div class="dwform-row">
                                <label class="label-field-short">Manu. By:</label>
                                    <span class="form-required"></span>

                                      <dw-dropdown [disabled]="!isEditing"
                                                 [selectedItem]="selectedManuBy?.id"
                                                 [dataSource]="manufactureByList"
                                                 (itemSelected)="manuBySelected($event)"
                                                 [controlWidth]="'398px'"
                                                 [enableSearch]="true"
                                                 matTooltip="Select manufactured by">
                                    </dw-dropdown>
                                </div>
                            <div class="dwform-row-gap"></div>
                            <div class="dwform-row">
                                <label class="label-field-short">Manu. For:</label>
                                <span class="form-required"></span>

                                    <dw-dropdown [disabled]="!isEditing"
                                                 [selectedItem]="selectedManuFor?.id"
                                                 [dataSource]="manufactureForList"
                                                 (itemSelected)="manuForSelected($event)"
                                                 [controlWidth]="'398px'"
                                                 [enableSearch]="true"
                                                 matTooltip="Select manufactured for">
                                    </dw-dropdown>

                            </div>
                            <div class="dwform-row-gap"></div>
                            <div class="dwform-row">
                                <label class="label-field-short">Storage:</label> <span
                                    class="form-required"></span>
                                <textarea class="input-field text-area-override"
                                        placeholder="<storage instructions>" [disabled]="!isEditing"
                                        style="vertical-align:top; height: 80px; width: 398px;
                                        text-transform: uppercase"
                                        [(ngModel)]="valStorageInstructions"></textarea>
                            </div>
                            <div class="dwform-row-gap"></div>
                            <div class="dwform-row">
                                <label class="label-field-short">AWP:</label> <span
                                    class="form-required"></span>
                                <p-inputNumber [inputStyleClass]="'input-field'"
                                               [disabled]="!isEditing" placeholder="<price>"
                                               [(ngModel)]="valAWP" mode="currency" currency="USD"
                                               locale="en-US" type="text"
                                               [inputStyle]="{'width': '100px', 'background':
                                               isEditing?'white':'inherit'}">

                                </p-inputNumber>
                            </div>
					</div>
				</div>
				<!-- ends the form -->
				<div [hidden]='!strErr.length' style="left: 10px;bottom: 13px;"
					class="error-line">{{strErr}}</div>
				<!-- save strip -->
				<div class="save-close-strip" style="bottom: 5px;">

					<button mat-button class="command-button" *ngIf="this.isEditing"
						(click)="submitRecord()" matTooltip="Submit the selected record"
						mat-button>
						<mat-icon>check_circle_outline</mat-icon>
						Submit
					</button>
					<button mat-button class="command-button" *ngIf="this.isEditing"
						(click)="cancelSubmitRecord()" matTooltip="Cancel edit" mat-button>
						<mat-icon>highlight_off</mat-icon>
						Cancel
					</button>
				</div>
			</div>
            </div>
			</mat-tab>
			<mat-tab label="History" [disabled]="isEditing">
			<div class="sub-tab-container-class detail-tab-additional">
				<transaction-history #history></transaction-history>
			</div>
			</mat-tab> </mat-tab-group>
		</div>
	</div>
	</mat-drawer-container>
</div>

<p-dialog header="Medication Search" [focusOnShow]="false"
          [(visible)]="displaySearchDlg" [modal]="true"
          [style]="{width: '630px', height: '245px'}"
          appendTo="body"
          [minY]="35" [resizable]="false" [closable]="true" >
    <app-search-medications #search
          (submitClicked)="globalSearchSelect($event)"
          [callFrom]="'medications'"
          (cancelClicked)="displaySearchDlg=false">
    </app-search-medications>
</p-dialog>

<p-dialog header="Medication Family Lookup" [focusOnShow]="false"
          [(visible)]="displayMedFamilyDlg" [modal]="true"
          [style]="{width: '730px', height: '550px'}"
          appendTo="body"
          [minY]="35" [resizable]="false" [closable]="true" >
    <app-medfamlookup #medFamilyLookup
        [MedFamRecords]="medicationFamilyList"
        (cancelClicked)="displayMedFamilyDlg=false"
        (submitClicked)="setMedicationFamilyRecord($event)">
    </app-medfamlookup>
</p-dialog>
